var ProxyUrl = "https://" +  window.location.host + "/" + document.querySelector(['script[data-id="proxy-url"]']).getAttribute('data-proxy-url')

$(document).ready(function() {
  /* Check if content loaded in iframe, if so hide header and footer of shopify site. */

  if (window.self !== window.top) {
    console.log('iframe: ', document.referrer);
    var header = document.querySelector('#shopify-section-header');
    header.style.display = 'none';
    var footer = document.querySelector('#shopify-section-footer');
    footer.style.display = 'none';
  } else {
    console.log('non-iframe: ', document.referrer);
  }


  var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
  var days_short = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];
  var months = ['January','February','March','April','May','June','July','August','September','October','November','December'];

  var year = new Date(Date.now()).getFullYear();

  function convertDateToUTC(date) {
    return new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds());
  }
  /**
  * Helps to format Dates input single d, outputs dd.
  * ie. addZ(2) => '02'
  */
  function addZ(n){return n<10? '0'+n:''+n;}

  var createAddressHtml = function(addresses, days_offset) {
    var addressBlocks = addresses.map(function(address, i) {
      var date_test = new Date(address.next_charge_scheduled_at)
      var date = address.next_charge_scheduled_at

      if (Object.prototype.toString.call(date_test) === "[object Date]") {
        if (isNaN(date_test.getTime())) {
          // invalid date.
        } else {
          var d = convertDateToUTC(new Date(address.next_charge_scheduled_at));
          d = new Date(d.setDate(d.getDate() + Number(days_offset)));
          // text must be formated Wednesday (10/20/2017)
          date = days[ d.getDay() ] + " ( " + addZ(d.getMonth() + 1) + "/" + addZ(d.getDate()) + "/" + d.getFullYear() + " )";
        }
      }

      var data = "data-date='"+ address.next_charge_scheduled_at +"' data-address-id='" + address.address_id + "' data-address-title='" + address.address_1.replace(/'/g, '`') + "'"
      var addressString = "<h6 class='title'>" + address.address_1.replace(/'/g, '`') + "</h6>";
      var nextDeliveryString = "<span class='date'><strong>Next Delivery: </strong> " + date + "</span>"
      var btn = "<div class='select-btn button btn btn-primary btn-lg'><span>" + "Select" + "</span></div>"
      var addressBlock = "<div " + data + " class='address'>" + btn + "<div class='description'>" + addressString + nextDeliveryString + "</div></div>";

      return addressBlock
    }).join('')
    return "<div class='form-group bamboo-radio-buttons'><label>Address and Delivery Date</label>" + addressBlocks + "</div>"
  }

  var addAddressListeners = function() {
    var $address = $('.address');
    var selectElement = document.getElementById('purchase_id');

    $address.each(function(i, address) {
      $(address).on('click', function(evt) {
        $address.each(function(i, a) {
          $(a).removeClass('selected');
          $(a).find('.button span').text('select');
        })

        $(this).toggleClass('selected');
        $(this).find('.button span').text('selected');
        selectElement.value = $(this).attr("data-address-id");
        $('#purchase_id').trigger('change');

        if ($(this).attr("data-date") === "Click to select and then choose date.") {
          $('#custom_date_container').show();
        } else {
          $('#custom_date_container').hide();
        }
      })
    })
  }

  /* ADD PRODUCT PAGE */
 if(window.location.href.indexOf('/add_product/product_detail') > -1){

   var customerId = window.location.href.split('customer/')[1].split('/')[0]
   var addressIds = [];
   $("#purchase_id option").each(function() {
     addressIds.push($(this).val());
   });

   // hide address and date dropdowns
   $('#product_dates_container').hide();
   $('#product_address_container').hide();

   // add loader
   var loader = document.createElement('DIV');
   var loader_label = document.createElement('Label');
   loader_label.textContent = "loading address info..."
   loader.appendChild(loader_label);
   loader.classList.add("bamboo-loader");
   $('#product_form button').before(loader);

   // remove unneed values for week.
   if($('#shipping_interval_unit_type').val().toLowerCase().includes("week")) {
     $("#shipping_interval_frequency option").each(function(i,el){
       if ( [1,2,4].indexOf( Number( el.value ) ) === -1 ) {
         // remove option
         el.remove();
       } else {
         el.textContent = el.value + " Weeks"
       }
     })
   } else if ($('#shipping_interval_unit_type').val().toLowerCase().includes("month")) {
     $("#shipping_interval_frequency option").each(function(i,el){
       if ( [1,3,6].indexOf( Number( el.value ) ) === -1 ) {
         // remove option
         el.remove();
       } else {
         el.textContent = el.value + " Months"
       }
     })
   }

   var nextShipment = ''
   var d = convertDateToUTC(new Date(nextShipment.value));

   $.ajax({
     type: "GET",
     url: ProxyUrl + "/customer_portal/recharge_delivery_delay",
            success: function(res) {
              console.log("success", res);
            },
            error: function(res) {
              console.log("error", res);
           }
     }).then(function(res){
       var rechargeDeliveryDelay = Number(res.rechargeDeliveryDelay);

       // change label text from shipment to delivery
       $('#purchase_id').on('change', function(evt){
         var address_label = document.querySelector('label[for^="address_"]');
         if (address_label) {
           address_label.textContent = "Next Delivery";
         }
         document.querySelector("[id^='address_'] option[value='']").setAttribute("hidden", true);
       })
       var $firstChargeDate = $('#first_charge_date');
       nextShipment = document.querySelector('#first_charge_date')

       d = convertDateToUTC(new Date(nextShipment.value));
       d = new Date(d.setDate(d.getDate() + rechargeDeliveryDelay));

       $firstChargeDate.on('change',function(evt){
         // Hide Custom Option
         var customOption = this.options[this.options.length - 1]
         customOption.setAttribute("hidden", true);

         // visually change charge date to delivery date
         var chosenoption = this.options[this.selectedIndex]
         if (chosenoption.value != "custom_date"){
            var d = convertDateToUTC(new Date(chosenoption.value));
            d = new Date(d.setDate(d.getDate() + rechargeDeliveryDelay));
            // text must be formated October 20th, 2017
            chosenoption.text = months[ d.getMonth() ] + " " + d.getDate() + ",  " + d.getFullYear();
         }
      })
   })

  $.ajax({
    type: "GET",
    url: ProxyUrl + "/customer_portal/add_product_page?address_ids=" + addressIds.join(','),
           success: function(res) {
             console.log("success", res);
           },
           error: function(res) {
             console.log("error", res);
          }
    }).then(function(res){
      /**
      * replace dropdowns with radio.
      */
      $('.bamboo-loader').hide()
      $('#next_charge_date_container').before(createAddressHtml(res.subscriptions, res.rechargeDeliveryDelay))
      addAddressListeners();
      $('.address')[0].click()
    });

    // DatePicker for custom date.
    $.ajax({
      type: "GET",
      url: ProxyUrl + "/customer_portal/date_picker",
             success: function(res) {
               console.log("success", res);
             },
             error: function(res) {
               console.log("error", res);
            }
      }).then(function(res){
        var datePickerElement = document.createElement('INPUT');
        datePickerElement.id = 'DatePicker';
        var datePickerParent = document.querySelector('#next_charge_date_container');
        datePickerParent.insertBefore(datePickerElement, datePickerParent.children[1]);
        var $firstChargeDate = $('#first_charge_date');

        $('#DatePicker').datepicker({
          startDate: (res.startDate !== null ? new Date(res.startDate): null),
          endDate: (res.endDate !== null ? new Date(res.endDate) : null),
          filter: function(date) {
            var formattedDate = addZ(date.getMonth() + 1) + '/' + addZ(date.getDate()) + '/' +  date.getFullYear()
            var wday = date.getDay()
            // disable deliverys dates based on non-operation days and blackouts
            if (res.nonDeliveryDays.includes(wday)) {
              return false;
            }
            if (res.blackoutDates.includes(formattedDate)) {
              return false;
            }
          },
          pick: function(date, obj) {
            var d = new Date(date)
            var chargeDate = new Date(d.setDate(d.getDate() - res.rechargeDeliveryDelay))
            $firstChargeDate.val(chargeDate.getFullYear() + '-' + addZ(chargeDate.getMonth() + 1) + '-' + addZ(chargeDate.getDate()))
          }
        });
        $('#DatePicker').datepicker("setDate", addZ(d.getMonth() + 1) +"/"+ addZ(d.getDate()) +"/"+ d.getFullYear());
      });

} // END ADD PRODUCT

  if(window.location.href.indexOf('/subscriptions') > -1 && window.location.href.indexOf('/items') === -1){
    var chargeDateHeader = document.querySelectorAll('#hidden-header-ReCharge .th-next-charge-date');

    chargeDateHeader.forEach(function(header, i) {
      header.innerHTML = "Next Delivery Date";
    })
    $.ajax({
      type: "GET",
      url: ProxyUrl + "/customer_portal/recharge_delivery_delay",
             success: function(res) {
               console.log("success", res);
             },
             error: function(res) {
               console.log("error", res);
            }
      }).then(function(res){
        var rechargeDeliveryDelay = Number(res.rechargeDeliveryDelay);

        var chargeDate = document.querySelectorAll('.td-next-charge-date')
        chargeDate.forEach(function(date, i) {
          if ( Object.prototype.toString.call(new Date(date.innerHTML.trim())) === "[object Date]" ) {
            // it is a date
            if ( isNaN( (new Date(date.innerHTML.trim())).getTime() ) ) {  // d.valueOf() could also work
              // date is not valid
            }
            else {
              // date is valid

              // Account for future Dates with a greater Year.
              if (new Date(Date.now()).getMonth() > new Date(date).getMonth()) {
                d = new Date(date.innerHTML.trim().concat(" " + ( year + 1 )));
              } else {
                d = new Date(date.innerHTML.trim().concat(" " + year));
              }

              deliveryDate = new Date(d.setDate(d.getDate() + rechargeDeliveryDelay));
              date.innerHTML = days[ deliveryDate.getDay() ] + ",  " + months[ deliveryDate.getMonth() ] + " " + deliveryDate.getDate() + " " + deliveryDate.getFullYear();
            }
          }
          else {
            // not a date
          }
        })
      });
  } // end subscriptions and items page

  /* SUBSCRIPTION PAGE */
  if(window.location.href.indexOf('/subscriptions') > -1){
    // duplicate add product button for each subscription
    var $addProductButton = $('#content__subscriptions .btn-primary');
    var $subscriptions = $('.re__subscriptions__subscription');
    var subscriptionCount = $subscriptions.length;

    $subscriptions.each(function(index, element) {
      $addProductButton.clone().appendTo(element)
    })
    $addProductButton.hide();

    // Alter Ships To => Delivery Address;
    $('.purchase-address strong').text("Delivery Address");
  } // end subscriptions page

  if(window.location.href.indexOf('/subscriptions/items') > -1 || window.location.href.indexOf('/subscription/') > -1){
    var $chargeContainer = $('#rc_subscriptions__items__next_shipment');
    $chargeContainer.find('label').text('Next Delivery');
    $chargeContainer.find('a').text("Change next delivery date");

    var datePickerElement = document.createElement('INPUT');
    datePickerElement.id = 'DatePicker';
    var datePickerParent = document.querySelector('#rc_subscriptions__items__next_shipment .rc_toggler__block:last-of-type');
    datePickerParent.insertBefore(datePickerElement, datePickerParent.children[1]);

    $.ajax({
      type: "GET",
      url: ProxyUrl + "/customer_portal/date_picker",
             success: function(res) {
               console.log("success", res);
             },
             error: function(res) {
               console.log("error", res);
            }
      }).then(function(res){

        $('#DatePicker').datepicker({
          startDate: (res.startDate !== null ? new Date(res.startDate): null),
          endDate: (res.endDate !== null ? new Date(res.endDate) : null),
          filter: function(date) {
            var formattedDate = addZ(date.getMonth() + 1) + '/' + addZ(date.getDate()) + '/' +  date.getFullYear()
            var wday = date.getDay()
            // disable deliverys dates based on non-operation days and blackouts
            if (res.nonDeliveryDays.includes(wday)) {
              return false;
            }
            if (res.blackoutDates.includes(formattedDate)) {
              return false;
            }
          }
        });

        var saveSelector = document.querySelector('#save_next_shipment');
        saveSelector.id = 'save_next_shipment__delivery'
        $(document).on('click', '#save_next_shipment__delivery', function(e) {
          e.preventDefault();
          var item_id = $(this).data('item-id');
          save_next_shipment__delivery(item_id, res.rechargeDeliveryDelay);
        });

        var daySelectElement = document.querySelector('#shipping_day');
        var monthSelectElement = document.querySelector('#shipping_month');
        var yearSelectElement = document.querySelector('#shipping_year');
        daySelectElement.style.display = "none"
        monthSelectElement.style.display = "none"
        yearSelectElement.style.display = "none"

        var nextShipmentSelector = document.querySelector('#rc_subscriptions__items__next_shipment .rc_toggler__block:first-of-type');
        var nextChargeDate = new Date(nextShipmentSelector.childNodes[2].textContent.trim());
        nextChargeDate = new Date(nextChargeDate.setDate(nextChargeDate.getDate() + res.rechargeDeliveryDelay));
        nextShipmentSelector.childNodes[2].textContent = days[ nextChargeDate.getDay() ] + ",  " + months[ nextChargeDate.getMonth() ] + " " + nextChargeDate.getDate() + " " + nextChargeDate.getFullYear();
      });
  } // end items page

  /* DELIVERY PAGE */
  if(window.location.href.indexOf('/orders/schedule') > -1){
    $.ajax({
      type: "GET",
      url: ProxyUrl + "/customer_portal/recharge_delivery_delay",
             success: function(res) {
               console.log("success", res);
             },
             error: function(res) {
               console.log("error", res);
            }
      }).then(function(res){
        var rechargeDeliveryDelay = Number(res.rechargeDeliveryDelay);

        // change charge date to delivery date.
        var deliveryScheduleDates = document.querySelectorAll(".re__schedule__order__date__ strong");
        deliveryScheduleDates.forEach(function(date, i) {
          var d = new Date(date.innerHTML.trim())
          var deliveryDate = new Date(d.setDate(d.getDate() + rechargeDeliveryDelay));
          date.innerHTML = days[ deliveryDate.getDay() ] + ",  " + months[ deliveryDate.getMonth() ] + " " + deliveryDate.getDate() + " " + deliveryDate.getFullYear();
        })

      })
  } // end delivery page

  function save_next_shipment__delivery(item_id, rechargeDeliveryDelay) {
  	if (window.lock === 'locked') { showNotification('Still waiting...'); return false; } else { window.lock = 'locked'; }
  	// Saving the next shipment date takes a while, so let the customer know it's processing
  	showNotification('Your action is being processed, please wait...', true);

  	var purchase_item_id = item_id;
  	var purchase_id = 3954679;

    // subtract one day from delivery date to get charge date.
    var datePickerDate = new Date(new Date($('#DatePicker').val()) - rechargeDeliveryDelay);
  	var shipping_year = $('#shipping_year').val(datePickerDate.getFullYear()).val();
  	var shipping_month = $('#shipping_month').val(datePickerDate.getMonth() + 1).val();
  	var shipping_day = $('#shipping_day').val(datePickerDate.getDate()).val();
  	var first_charge_date = shipping_year + '-' + shipping_month + '-' + shipping_day;

  	var url = '/tools/recurring/purchase_item/' + purchase_item_id + '/change_next_queued_charge_date_of_item_within_same_purchase/' + first_charge_date;
  	var data = {
  		'purchase_id': purchase_id,
  		'first_charge_date': first_charge_date,
  		'action': 'customer moved date'
  	};
  	$.ajax({
  		type: 'POST',
  		url: url,
  		data: data,
  		success: function(response) {
  			if (response == 'Date is incorect') {
  				showErrorNotification('There are not that many days in the month');
  			} else if (response == "Date is in the past" || response == "Date is not far enough in the future"){
  				showErrorNotification("You can't choose a date in the past");
  			} else {
  				showNotificationAfterReload('Next shipment date updated');
  				window.location.reload();
  			}
  		},
  		error: function() {
  			showErrorNotification('Could not save next shipment date. Please contact support@recahrgeapps.com');
  		},
  		complete: function() {
  			window.lock = "open";
  		}
  	});
  }
  function rc_createCookie(name, value, days) {
  	var expires;
  	if (days) {
  		var date = new Date();
  		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
  		expires = "; expires=" + date.toGMTString();
  	} else {
  		expires = "";
  	}
  	document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
  }
  function rc_readCookie(name) {
  	var nameEQ = encodeURIComponent(name) + "=";
  	var ca = document.cookie.split(';');
  	for (var i = 0; i < ca.length; i++) {
  		var c = ca[i];
  		while (c.charAt(0) === ' ') c = c.substring(1, c.length);
  		if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length, c.length));
  	}
  	return null;
  }
  function rc_deleteCookie(name) {
  	rc_createCookie(name, "", -1);
  }
  var notify_timeout = false;
  function rc_showErrorNotification(message, disable_timeout){
  	$('#rc_notification').css({'background': '#FE2E2E'});
  	$('#rc_notification .message-notification').html(message);
  	$('#rc_notification').animate({
  		height: '86px'
  	}, 100);
  	if (notify_timeout){
  		clearTimeout(notify_timeout);
  	}
  	if (!disable_timeout) {
  		notify_timeout = setTimeout(function(){
  			$('#rc_notification').animate({
  				height: '0'
  			}, 100);
  		}, 3000);
  	}
  }
  function rc_showNotification(message, disable_timeout){
  	$('#rc_notification').css({'background': '#43AC6A'});
  	$('#rc_notification .message-notification').html(message);
  	$('#rc_notification').animate({
  		height: '86px'
  	}, 100);
  	if (notify_timeout){
  		clearTimeout(notify_timeout);
  	}
  	if (!disable_timeout){
  		notify_timeout = setTimeout(function(){
  			$('#rc_notification').animate({
  				height: '0'
  			}, 100);
  		}, 3000);
  	}
  }
  function rc_showNotificationAfterReload(message) {
  	rc_createCookie("success_msg", message);
  }
  function rc_showErrorNotificationAfterReload(message) {
  	rc_createCookie("error_msg", message);
  }
  function showErrorNotification(message, disable_timeout) {
  	rc_showErrorNotification(message, disable_timeout);
  }
  function showNotification(message, disable_timeout) {
  	rc_showNotification(message, disable_timeout);
  }
  function showErrorNotificationAfterReload(message) {
  	rc_showErrorNotificationAfterReload(message);
  }
  function showNotificationAfterReload(message) {
  	rc_showNotificationAfterReload(message);
  }
  $(function(){
  	var success_msg = rc_readCookie("success_msg");
  	if (success_msg) {
  		rc_showNotification(success_msg);
  		rc_deleteCookie("success_msg");
  	}
  	var error_msg = rc_readCookie("error_msg");
  	if (error_msg) {
  		rc_showErrorNotification(error_msg);
  		rc_deleteCookie("error_msg");
  	}
          $(document).on('change', '#ReCharge-Mobile-Nav', function(e) {
          	var page_url = $(this).find("option:selected").val()
              window.location.href = page_url;
          });

  });

})
